export default {
  name: 'step-up-answer-list',
  created () {
    if (document.referrer.indexOf('edit') != -1) {
      this.stepUpUser = this.$route.query.answer.step_up_user
      this.answerContent = this.$route.query.answer.answer_content
    } else {
      this.search()
    }
  },
  data () {
    return {
      isAllAnswer: false,
      stepUpUser: null,
      answerContent: null,
      selectAnswers: [
        {id: 0, content: '未選択'},
        {id: 1, content: `努力が<br/>必要`},
        {id: 2, content: 'もう一歩'},
        {id: 3, content: 'できてる'},
        {id: 4, content: `大変よく<br/>できてる`}
      ]
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      let data = {
        id: this.$route.params.step_up_answer_id
      }

      let res = await this.$store.dispatch('STEPUP_ANSWER_DETAIL_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.stepUpUser = res.step_up_user
      this.answerContent = res.step_up_answer_details
    },
    goTop: function () {
      this.$router.push({path: '/'})
    },
    goStepUpAnswerEdit: function () {
      this.$router.push({ path: '/stepup/' + this.$route.params.step_up_answer_id + '/edit' })
    },

    async updateAnswers () {
      let data = {
        answerContent: this.answerContent
      }
      await this.$store.dispatch('STEPUP_ANSWER_UPDATE', {id: this.$route.params.step_up_answer_id, data: data})
      .catch(err => {
        console.log(err)
        return
      })
      // モーダル表示
      this.stepupSendModal()
    },
    selectedStyle: function (index, radioVal) {
      if (this.answerContent[index].answer_content == radioVal) {
        return true
      }
      return false
    },
    isAllAnswerQuestion: function () {
      for (let i = 0; i < this.answerContent.length; i++) {
        if (this.answerContent[i].answer_content != 0) {
          this.isAllAnswer = true
        } else {
          this.isAllAnswer = false
          return
        }
      }
    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    stepupSendModal: function () {
      const button = document.getElementById('stepupSendModalButton')
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/step-up-answer-list.js